const actions = {
  // 存储令牌
  setToken({ commit }, data) {
    commit('setToken', data);
    sessionStorage.setItem('access_token', data);
  },
  // 清除令牌
  clearToken({ commit }, data) {
    commit('clearToken', null);
    sessionStorage.setItem('access_token', data);
  }
  // 初始化时检查令牌有效性
  // async checkToken() {
  //     if (!this.token) return false;
  //     try {
  //         // 调用后端接口校验令牌
  //         const res = await axios.get('/api/verify-token');
  //         this.userInfo = res.data.user;
  //         return true;
  //     } catch (err) {
  //         this.clearToken();
  //         return false;
  //     }
  // }
};

export default actions;
